import { useCallback, useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { memberName } from "./clientReviewUtils";

/**
 * Opens the existing member + programme Notepad for a review row: the review's programme first,
 * then the member's other active programmes. When the notepad opened from here closes, the review
 * lists reload so the Notes column shows the saved note.
 */
export default function useReviewNotes() {
  const { isOpenNotePad, setIsOpenNotePad, setSelectedNotepad } = useContentSetting();
  const queryClient = useQueryClient();
  const openedHere = useRef(false);

  useEffect(() => {
    if (isOpenNotePad || !openedHere.current) return;
    openedHere.current = false;
    ["clientReviews", "clientReviewsCardOverdue", "dashboardData"].forEach((key) =>
      queryClient.invalidateQueries({ queryKey: [key] })
    );
  }, [isOpenNotePad, queryClient]);

  return useCallback(
    (row) => {
      const otherProgrammes = (row.active_programs || []).filter(
        (p) => String(p._id) !== String(row.program_id)
      );
      setSelectedNotepad({
        title: memberName(row),
        images: null,
        member_id: row.member_id,
        _id: row.program_id,
        program_list: [{ _id: row.program_id, title: row.program_title }, ...otherProgrammes],
        message: "This notepad is specific to this member for the selected programme.",
        type_member: true,
      });
      openedHere.current = true;
      setIsOpenNotePad(true);
    },
    [setIsOpenNotePad, setSelectedNotepad]
  );
}
